import { useInvalidateAllocations } from '@features/allocation';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { projectListQueries } from '../queries';
import { projectListService } from '../services/projectListService';
import type { ProjectRow, ProjectUpdateBody } from '../types/ProjectList';

export type UpdateProjectVariables = { id: number; body: ProjectUpdateBody };

/**
 * `PATCH /projects/management/:id` (admin). Invalida a lista de projetos e as
 * telas de alocação (interno/pool mudam o comportamento da alocação).
 */
export function useUpdateProject() {
  const qc = useQueryClient();
  const invalidateAllocations = useInvalidateAllocations();
  return useMutation<ProjectRow, unknown, UpdateProjectVariables>({
    mutationFn: ({ id, body }) => projectListService.update(id, body),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: projectListQueries.lists() });
      invalidateAllocations();
    },
  });
}
